<template>
	<div>
		<div class="head_order">
			<div class="order_logo">
				<router-link to="/">
					<LOGO />
				</router-link>
			</div>
			<div class="mobile_only head_order_title">תשלום</div>
			<div class="backto_bt backto_bt-cart">
				<router-link :to="getReturnData['url']">
					{{ getReturnData["text"] }}
					<span>></span>
					<CART2 />
				</router-link>
			</div>
		</div>
		<section class="page_padd page_padd_m">
			<div class="login_box pay_box">
				<div class="corner-top"></div>
				<div class="no_mobile title_has_svg">
					<lock-big></lock-big>
					<h2 class="title center">עמוד תשלום באשראי</h2>
				</div>
				<div class="login_inner">
					<div class="pay_box_gray">
						<img :src="assets_url + '/layout/pci.png'" />
						<b>תשלום מאובטח בכרמלה</b>
						<br />היי, תהליך הרכישה באתר שלנו מאובטח על פי תקן PCI העולמי (מאושר על ידי כל חברות האשראי
						לביצוע עסקאות ברשת). פרטי הכרטיס שלך יישארו מוצפנים, מאובטחים ורק שלך - אפשר להמשיך בלב שקט.
					</div>
					<div class="pay-cards">
						<img :src="assets_url + '/layout/pay-cards.png'" />
					</div>
          <div class="errors" v-if="errors.length">
            <div class="error" v-for="(error, index) in errors" :key="index" v-html="error"></div>
            <div class="bt_green ease">
              <router-link to="/checkout">חזרה לעמוד תשלום</router-link>
            </div>
          </div>
					<iframe v-if="!errors.length" :src="paymentIframe" frameborder="0" height="300"></iframe>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import LOGO from "../assets/img/logo.svg";
	import LockBig from "../assets/img/lock-big.svg";
	import CART2 from "../assets/img/cart2.svg";
	import OrderTimeUp from "../components/Popups/Ordertimeup";
	import LOCK from "../assets/img/lock.svg";
	import { mapState } from "vuex";
	export default {
		data() {
			return {
				assets_url: wpData.assets_url,
        errors: []
			};
		},
		props: {
			return_url: {
				type: String,
				default: "/"
			},
			return_text: {
				type: String,
				default: "בחזרה לעגלה"
			}
		},
		mounted() {
			let time = 1000 * 60 * 15;
			//let time = 10000;
			setTimeout(() => {
				//this.$modal.show('order_timeup');
				this.removeThisOrder();
			}, time);

      if (wpData.payment_url) {
        this.$store.commit("setPaymentForm", wpData.payment_url);
      }

			localStorage.removeItem("formFields");
			this.$store.commit("clearFormFields");

      window.addEventListener("message", message => {
        console.log(message)
        if (message.data.payment_error) {
          this.errors.push(message.data.payment_error);
        }
      })
    },
		methods: {
			removeThisOrder() {
				let newUrlLink = homeUrl + "checkout/?removeOrder=" + this.orderID;
				window.location = newUrlLink;
			}
		},
		computed: {
			...mapState(["paymentIframe"]),
			iframe() {
				return "";
			},
			orderID() {
				return this.$route.params.orderId;
			},
			getReturnData() {
				// if its a gift card purchase payment screen
				if (window.location.search.indexOf("is_gift_card_purchase=true") >= 0) {
					return {
						url: "../../../gift-card/pay",
						text: "בחזרה לגיפט קארדים"
					};
				} else {
					return {
						url: "/",
						text: "בחזרה לעגלה"
					};
				}
			}
		},
		components: {
			LOGO,
			CART2,
			LockBig,
			LOCK,
			OrderTimeUp
		}
	};
</script>

<style scoped lang="sass">
.errors
  padding: 1em 0 2em

  .error
    color: red
    font-weight: bold

  a
    padding: 0
</style>
